import styled from 'styled-components';
import {SWIPER_MODE} from '../../../css-constants';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';
import {HOME_PAGE, LOBBY_PAGE, WIDE_GRID} from '../../../../../themes/css-global-classes';

export interface GameBoxProps {
    squareGameIcon: boolean;
}

const DefaultBox = styled.div<GameBoxProps>`
    position: relative;
    margin-top: 10px;
    margin-bottom: 3rem;
    width: 20%;
    text-align: center;
    cursor: pointer;
    user-select: none;


    &.${SWIPER_MODE} {
      flex-shrink: 0;
      justify-content: center;
    }
`;

export const PcBox = styled(DefaultBox)`
     .${HOME_PAGE} &.${SWIPER_MODE} {
          width: 16.6667%;
     }

     @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        .${LOBBY_PAGE} &  {
          padding-left: 1%;
          padding-right: 1%;
          width: 25%;
        }
     }

     @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        margin-right: ${props => props.squareGameIcon ? '15px' : '0'};
        .${WIDE_GRID} & {
             width: calc(100% / 6);
        }
     }

     .${WIDE_GRID} & {
        width: calc(100% / 7);
     }
`;

export const MobileBox = styled(DefaultBox)`
    padding: 0 4px;
    margin-bottom: 0;

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        width: 16.667%;
        &.${SWIPER_MODE} {
            width: 16%;
        }
    }
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        width: 16.667%;
        &.${SWIPER_MODE} {
            width: 16.1%;
        }
    }
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        width: 20%;
        &.${SWIPER_MODE} {
            width: 19%;
        }
    }
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        width: 33.3333%;
        &.${SWIPER_MODE} {
            width: 31%;
        }
    }
`;

export const GameDefaultBox = styledByDevice(PcBox, MobileBox);